module.exports = __webpack_public_path__ + "static/media/protocogotas_text_02.f22b124c.jpg";